/*
 * @Description: 
 */

import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { ElMessage } from 'element-plus'
import './assets/css/fonts.css'
import naive from 'naive-ui'
import { createDiscreteApi } from 'naive-ui'


// 如果您正在使用CDN引入，请删除下面一行。
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 添加全局的未处理 Promise 拒绝处理器
window.addEventListener('unhandledrejection', function (event) {
  console.error('未处理的 Promise 拒绝:', event.reason)
  // 防止默认的错误处理
  event.preventDefault()
})

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(router)
app.use(ElementPlus)
app.use(naive)



// 创建 Naive UI 的离散 API
const { message, dialog, notification, loadingBar } = createDiscreteApi([
  'message',
  'dialog',
  'notification',
  'loadingBar'
])

app.config.globalProperties.$message = message
app.config.globalProperties.$dialog = dialog
app.config.globalProperties.$notification = notification
app.config.globalProperties.$loadingBar = loadingBar

// 将实例挂载到 window 对象，以便在非组件上下文中使用
window.$naive = {
  $message: message,
  $dialog: dialog,
  $notification: notification,
  $loadingBar: loadingBar
}
app.mount('#app')

